import { observer } from "mobx-react-lite";
import React from "react";
import styled from "styled-components";

interface IProps {
    count: number | undefined;
}

export const ApprovalCounter: React.FC<IProps> = observer((props) => {
    return <CounterSpan className="approval-counter">{props.count}</CounterSpan>;
});

export const CounterSpan = styled.span`
    align-items: center;
    background-color: #d32f2f;
    border-radius: 12px;
    color: white;
    display: inline-flex;
    font-size: 12px;
    height: 24px;
    justify-content: center;
    margin-left: 6px;
    min-width: 24px;
    padding: 0 4px !important;
    border: none !important;
`;
